module.exports = __webpack_public_path__ + "noitems-v1-9efb1e5b.png";